<template>
  <BaseCard>
    <div class="px-6 pb-3">
      <div class="text-sm font-medium text-muted-foreground">{{ title }}</div>
    </div>
    <div class="px-6">
      <div class="space-y-2">
        <div class="flex items-baseline justify-between">
          <div>
            <div class="text-2xl font-bold">{{ formatValue(realizado, format) }}</div>
            <div class="text-xs text-muted-foreground mt-1">Meta: {{ formatValue(meta, format) }}</div>
          </div>
          <div class="text-right">
            <div :class="['text-lg font-bold', percentage >= 100 ? 'text-secondary' : percentage >= 80 ? 'text-primary' : 'text-destructive']">
              {{ percentage.toFixed(0) }}%
            </div>
            <div class="flex items-center justify-end space-x-1 text-xs text-muted-foreground">
              <IconTrendingUp v-if="variance > 0" :className="'w-3 h-3 text-secondary'" />
              <IconTrendingDown v-else-if="variance < 0" :className="'w-3 h-3 text-destructive'" />
              <IconMinus v-else :className="'w-3 h-3'" />
              <span>{{ formatValue(Math.abs(variance), format) }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </BaseCard>
</template>

<script>
import BaseCard from '@/components/ui/BaseCard.vue'
import { formatValue } from '@/lib/kpi-data'
import IconTrendingUp from '@/components/icons/IconTrendingUp.vue'
import IconTrendingDown from '@/components/icons/IconTrendingDown.vue'
import IconMinus from '@/components/icons/IconMinus.vue'

export default {
  name: 'KPICard',
  components: { BaseCard, IconTrendingUp, IconTrendingDown, IconMinus },
  props: {
    title: { type: String, required: true },
    meta: { type: Number, required: true },
    realizado: { type: Number, required: true },
    format: { type: String, required: true },
  },
  computed: {
    percentage() {
      return this.meta > 0 ? (this.realizado / this.meta) * 100 : 0
    },
    variance() {
      return this.realizado - this.meta
    },
  },
  methods: {
    formatValue,
  },
}
</script>

